const partnershipIntegrationCompareData = [
  {
    serviceCategory: '合作与整合',
    service: '独家Chowbus送餐服务',
    serviceCategory_foreign: 'Partnership & Integration',
    service_foreign: 'Exclusive Delivery Service',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '合作与整合',
    service: '第三方外卖平台集成',
    serviceCategory_foreign: 'Partnership & Integration',
    service_foreign: 'Third Party Delivery Integrations',
    chowbus: true,
    toast: true,
    clover: false,
    square: false,
    menusifu: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '合作与整合',
    service: '市场平台集成',
    serviceCategory_foreign: 'Partnership & Integration',
    service_foreign: 'Marketplace Integration',
    chowbus: true,
    toast: true,
    clover: false,
    square: true,
    menusifu: false,
    zbs_pos: false,
  },
];

const digitalOrderingCompareData = [
  {
    serviceCategory: '数字点餐',
    service: '二维码点餐',
    serviceCategory_foreign: 'Digital Ordering',
    service_foreign: 'QR Code Ordering',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '数字点餐',
    service: '平板点餐',
    serviceCategory_foreign: 'Digital Ordering',
    service_foreign: 'Tablet Ordering',
    chowbus: true,
    toast: false,
    clover: false,
    square: false,
    menusifu: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '数字点餐',
    service: '餐厅订单网页',
    serviceCategory_foreign: 'Digital Ordering',
    service_foreign: 'Restaurant Website Online Ordering',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '数字点餐',
    service: '智能⾃助点餐机',
    serviceCategory_foreign: 'Digital Ordering',
    service_foreign: 'Kiosk',
    chowbus: true,
    toast: true,
    clover: false,
    square: false,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '数字点餐',
    service: '外卖App',
    serviceCategory_foreign: 'Digital Ordering',
    service_foreign: 'Takeout & Delivery App',
    chowbus: true,
    toast: true,
    clover: false,
    square: false,
    menusifu: false,
    zbs_pos: false,
  },
];

const posFeatureCompareData = [
  {
    serviceCategory: 'POS功能',
    service: '针对亚洲餐厅的专属功能',
    serviceCategory_foreign: 'POS Features',
    service_foreign: 'Asian Restaurant Specific Features',
    chowbus: true,
    toast: false,
    clover: false,
    square: false,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: 'POS功能',
    service: '中英双语界面',
    serviceCategory_foreign: 'POS Features',
    service_foreign: 'Bilingual Interface in Chinese and English',
    chowbus: true,
    toast: false,
    clover: false,
    square: false,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: 'POS功能',
    service: '为餐厅定制的硬件设备',
    serviceCategory_foreign: 'POS Features',
    service_foreign: 'Hardware Built for Restaurants',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: 'POS功能',
    service: '云端自动备份',
    serviceCategory_foreign: 'POS Features',
    service_foreign: 'Automatic Backups in the Cloud',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: false,
    zbs_pos: false,
  },
  {
    serviceCategory: 'POS功能',
    service: '专门向餐厅销售',
    serviceCategory_foreign: 'POS Features',
    service_foreign: 'Sells Exclusively to Restaurants',
    chowbus: true,
    toast: true,
    clover: false,
    square: false,
    menusifu: false,
    zbs_pos: true,
  },
];

const orderTableManagementCompareData = [
  {
    serviceCategory: '订单和桌位管理',
    service: '等位系统',
    serviceCategory_foreign: 'Order & Table Management',
    service_foreign: 'Waitlist',
    chowbus: true,
    toast: true,
    clover: false,
    square: false,
    menusifu: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '订单和桌位管理',
    service: '多平台云端订单管理',
    serviceCategory_foreign: 'Order & Table Management',
    service_foreign: 'Cloud Multi-platform Order Management',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: false,
    zbs_pos: false,
  },
];

const menuTeamManagementData = [
  {
    serviceCategory: '菜单和团队管理',
    service: '餐厅集团管理',
    serviceCategory_foreign: 'Menu & Team Management',
    service_foreign: 'Restaurant Group management',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '菜单和团队管理',
    service: '主账户',
    serviceCategory_foreign: 'Menu & Team Management',
    service_foreign: 'Master Account',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '菜单和团队管理',
    service: '工资支付',
    serviceCategory_foreign: 'Menu & Team Management',
    service_foreign: 'Payroll',
    chowbus: false,
    toast: true,
    clover: true,
    square: true,
    menusifu: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '菜单和团队管理',
    service: '员工绩效',
    serviceCategory_foreign: 'Menu & Team Management',
    service_foreign: 'Employee Performance',
    chowbus: true,
    toast: true,
    clover: true,
    square: false,
    menusifu: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '菜单和团队管理',
    service: '多平台云端菜单管理',
    serviceCategory_foreign: 'Menu & Team Management',
    service_foreign: 'Cloud Multi-platform Menu Management',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: false,
    zbs_pos: false,
  },
];

const paymentProcessingCompareData = [
  {
    serviceCategory: '支付处理',
    service: '多种支付方式',
    serviceCategory_foreign: 'Payment Processing',
    service_foreign: 'Multiple Payment Methods',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '支付处理',
    service: '多种分账选项',
    serviceCategory_foreign: 'Payment Processing',
    service_foreign: 'Multiple Split Options',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '支付处理',
    service: '会员促销',
    serviceCategory_foreign: 'Payment Processing',
    service_foreign: 'Membership Promotion',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
];

const reportingAnalyticsCompareData = [
  {
    serviceCategory: '报告与分析',
    service: '销售数据报告',
    serviceCategory_foreign: 'Reporting & Analytics',
    service_foreign: 'Sales Data Report',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: true,
  },
  {
    serviceCategory: '报告与分析',
    service: '个性化小费分配',
    serviceCategory_foreign: 'Reporting & Analytics',
    service_foreign: 'Personalized Tip Allocation',
    chowbus: true,
    toast: true,
    clover: false,
    square: false,
    menusifu: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '报告与分析',
    service: '顾客行为报告',
    serviceCategory_foreign: 'Reporting & Analytics',
    service_foreign: 'User Activity',
    chowbus: true,
    toast: true,
    clover: true,
    square: true,
    menusifu: true,
    zbs_pos: false,
  },
];

const cloudBasedPointOfSaleCompareData = [
  {
    serviceCategory: '云端餐饮管理系统',
    service: '订单管理 & 桌位管理',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service_foreign: 'Order & Table Management',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '云端餐饮管理系统',
    service: '报表系统 & 专业分析 ',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service_foreign: 'Reporting & Analytics',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '云端餐饮管理系统',
    service: '菜单管理 & 团队管理 ',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service_foreign: 'Menu & Team Management',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '云端餐饮管理系统',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service: '支付收单',
    service_foreign: 'Payment Processing',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '云端餐饮管理系统',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service: '多店报表&管理系统',
    service_foreign: 'Multi-location Management',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '云端餐饮管理系统',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service: '离线模式',
    service_foreign: 'Offiline Mode',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '云端餐饮管理系统',
    serviceCategory_foreign: 'Cloud-based Point of Sale',
    service: '跨店交易&结算系统',
    service_foreign: 'Multi-location Transaction System',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
];

const customerServiceCompareData = [
  {
    serviceCategory: '售后客服',
    serviceCategory_foreign: 'Customer Support',
    service: '全天候客服,30分钟内人工到店解决问题',
    service_foreign: '24/7, 30 mins On-site Support',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '售后客服',
    serviceCategory_foreign: 'Customer Support',
    service: '到店安装&连接网络',
    service_foreign: 'Installation & Network Configuration',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '售后客服',
    serviceCategory_foreign: 'Customer Support',
    service: '功能&软件自动升级 ',
    service_foreign: 'Automatic Feature & Software Upgrades',
    chowbus: true,
    menusifu: false,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '售后客服',
    serviceCategory_foreign: 'Customer Support',
    service: '电子 & 实体礼卡* ',
    service_foreign: 'Digital & Physical Gift Cards',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '售后客服',
    serviceCategory_foreign: 'Customer Support',
    service: '免费专业摄像',
    service_foreign: 'Free Photography',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
];

const SaveLaborAndSmartOrderingCompareData = [
  {
    serviceCategory: '智能点餐系统,帮您节省人工 ',
    serviceCategory_foreign: 'Save Labor w. Smart Ordering',
    service: '扫码点餐',
    service_foreign: 'QR Code Ordering',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '智能点餐系统,帮您节省人工 ',
    serviceCategory_foreign: 'Save Labor w. Smart Ordering',
    service: '网页点餐',
    service_foreign: 'Online Ordering',
    chowbus: true,
    menusifu: true,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '智能点餐系统,帮您节省人工 ',
    serviceCategory_foreign: 'Save Labor w. Smart Ordering',
    service: '智能自助点餐机',
    service_foreign: 'Kiosk Ordering',
    chowbus: true,
    menusifu: true,
    clover: false,
    square: false,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '智能点餐系统,帮您节省人工 ',
    serviceCategory_foreign: 'Save Labor w. Smart Ordering',
    service: '平板点餐',
    service_foreign: 'Tablet Ordering',
    chowbus: true,
    menusifu: true,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '智能点餐系统,帮您节省人工 ',
    serviceCategory_foreign: 'Save Labor w. Smart Ordering',
    service: '等位&预约',
    service_foreign: 'Waitlist & Reservation',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '智能点餐系统,帮您节省人工 ',
    serviceCategory_foreign: 'Save Labor w. Smart Ordering',
    service: '餐厅定制App*',
    service_foreign: 'Restaurant Branded App*',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
];

const crmLoyaltyCompareData = [
  {
    serviceCategory: '会员系统 & 客户关系管理解决方案',
    serviceCategory_foreign: 'Loyalty & CRM Solution',
    service: '餐厅专属会员系统',
    service_foreign: 'Restaurant Loyalty Program',
    chowbus: true,
    menusifu: false,
    clover: true,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '会员系统 & 客户关系管理解决方案',
    serviceCategory_foreign: 'Loyalty & CRM Solution',
    service: '集团跨店会员',
    service_foreign: 'Multi-location Loyalty System',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '会员系统 & 客户关系管理解决方案',
    serviceCategory_foreign: 'Loyalty & CRM Solution',
    service: '餐厅物料设计',
    service_foreign: 'Restaurant Material Design (1 time/Mo)',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '会员系统 & 客户关系管理解决方案',
    serviceCategory_foreign: 'Loyalty & CRM Solution',
    service: ' 会员短信营销',
    service_foreign: 'CRM',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: true,
    toast: false,
    zbs_pos: false,
  },
];

const deliveryGrowthsolutionCompareData = [
  {
    serviceCategory: '外卖增值解决方案',
    serviceCategory_foreign: 'Delivery Growth Solution',
    service: ' 餐厅网站设计制作',
    service_foreign: 'Website Design',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },

  {
    serviceCategory: '外卖增值解决方案',
    serviceCategory_foreign: 'Delivery Growth Solution',
    service: 'Google / Yelp 评论管理',
    service_foreign: 'Google / Yelp Review Management',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '外卖增值解决方案',
    serviceCategory_foreign: 'Delivery Growth Solution',
    service: '搜索引擎优化',
    service_foreign: 'Search Engine Optimization',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
  {
    serviceCategory: '外卖增值解决方案',
    serviceCategory_foreign: 'Delivery Growth Solution',
    service: '第三方外卖平台整合',
    service_foreign: '3rd Party Delivery Integration',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: true,
    toast: true,
    zbs_pos: false,
  },
  {
    serviceCategory: '外卖增值解决方案',
    serviceCategory_foreign: 'Delivery Growth Solution',
    service: '代申请开通第三方外卖平台',
    service_foreign: '3rd Party Delivery Applications',
    chowbus: true,
    menusifu: false,
    clover: false,
    square: false,
    toast: false,
    zbs_pos: false,
  },
];

const compareTalbeData = [
  cloudBasedPointOfSaleCompareData,
  customerServiceCompareData,
  SaveLaborAndSmartOrderingCompareData,
  // partnershipIntegrationCompareData,
  crmLoyaltyCompareData,
  // digitalOrderingCompareData,
  // posFeatureCompareData,
  // orderTableManagementCompareData,
  // menuTeamManagementData,
  // paymentProcessingCompareData,
  // reportingAnalyticsCompareData,
  deliveryGrowthsolutionCompareData,
];

export default compareTalbeData;

export const compareTargetOptions = [
  {
    label: 'Menusifu',
    value: 'menusifu',
  },
  {
    label: 'Clover',
    value: 'clover',
  },
  {
    label: 'Square',
    value: 'square',
  },

  {
    label: 'Toast',
    value: 'toast',
  },

  // {
  //   label: 'ZBS POS',
  //   value: 'zbs_pos',
  // },
];
